export const SEED_TEMPLATES = [
  // ── EMAIL TEMPLATES ──
  {
    id: "et1", channel: "EMAIL", templateType: "ACCEPTANCE", name: "Interview Acceptance",
    subject: "You're Invited to Interview at {{companyName}} — Please Confirm",
    body: `<h2>Dear {{candidateName}},</h2>
<p>We are pleased to invite you to an interview for the position of <strong>{{jobTitle}}</strong> at <strong>{{companyName}}</strong>.</p>
<p><strong>Opens:</strong> {{interviewDate}}<br/><strong>Expires:</strong> {{interviewExpiry}}<br/><strong>Estimated Duration:</strong> 20-30 minutes</p>
<p>Please let us know whether you'd like to accept or decline this invitation before it expires:</p>
<p>
  <a href="{{acceptUrl}}" style="background:#7B5AC4;color:white;padding:12px 28px;border-radius:8px;text-decoration:none;display:inline-block;font-weight:600;margin-right:8px">Accept Invitation</a>
  <a href="{{rejectUrl}}" style="background:#EF4444;color:white;padding:12px 28px;border-radius:8px;text-decoration:none;display:inline-block;font-weight:600">Reject Invitation</a>
</p>
<p>Once you accept, we'll share the interview link with you. If you have questions, reply to this email.</p>
<p>Best regards,<br/>{{companyName}} Hiring Team</p>`,
    isDefault: true, createdAt: "2026-04-01T10:00:00Z"
  },
  {
    id: "et2", channel: "EMAIL", templateType: "REMINDER", name: "Interview Reminder",
    subject: "Reminder: Please Confirm Your Interview for {{jobTitle}}",
    body: `<h2>Dear {{candidateName}},</h2>
<p>This is a friendly reminder that your invitation to interview for <strong>{{jobTitle}}</strong> at <strong>{{companyName}}</strong> is awaiting your response.</p>
<p><strong>Expires:</strong> {{interviewExpiry}}</p>
<p>Please confirm your participation before it expires:</p>
<p><a href="{{acceptUrl}}" style="background:#7B5AC4;color:white;padding:12px 28px;border-radius:8px;text-decoration:none;display:inline-block;font-weight:600">Respond Now</a></p>
<p>Best regards,<br/>{{companyName}} Hiring Team</p>`,
    isDefault: false, createdAt: "2026-04-02T10:00:00Z"
  },
  {
    id: "et2b", channel: "EMAIL", templateType: "INTERVIEW_LINK", name: "Send Interview Link",
    subject: "Your Interview Link for {{jobTitle}}",
    body: `<h2>Dear {{candidateName}},</h2>
<p>Thank you for accepting! Here is your interview link for <strong>{{jobTitle}}</strong> at <strong>{{companyName}}</strong>.</p>
<p><a href="{{interviewUrl}}" style="background:#7B5AC4;color:white;padding:12px 28px;border-radius:8px;text-decoration:none;display:inline-block;font-weight:600">Start Interview</a></p>
<p><strong>Estimated Duration:</strong> 20-30 minutes<br/>Please ensure you have a working webcam, microphone, and a stable internet connection in a quiet environment.</p>
<p>Best regards,<br/>{{companyName}} Hiring Team</p>`,
    isDefault: true, createdAt: "2026-04-02T11:00:00Z"
  },
  {
    id: "et3", channel: "EMAIL", templateType: "INTERVIEW_LINK", name: "Interview Completion Confirmation",
    subject: "Thank You for Completing Your Interview",
    body: `<h2>Dear {{candidateName}},</h2>
<p>Thank you for completing your interview for <strong>{{jobTitle}}</strong> at <strong>{{companyName}}</strong>.</p>
<p>Our team will review your responses and get back to you within 5 business days.</p>
<p>Best regards,<br/>{{companyName}} Hiring Team</p>`,
    isDefault: false, createdAt: "2026-04-03T10:00:00Z"
  },
  {
    id: "et4", channel: "EMAIL", templateType: "INTERVIEW_LINK", name: "Shortlisted Notification",
    subject: "Congratulations! You've Been Shortlisted for {{jobTitle}}",
    body: `<h2>Dear {{candidateName}},</h2>
<p>We're excited to inform you that you have been <strong>shortlisted</strong> for the next round of interviews for <strong>{{jobTitle}}</strong> at <strong>{{companyName}}</strong>.</p>
<p>You will receive details about the next steps shortly.</p>
<p>Best regards,<br/>{{companyName}} Hiring Team</p>`,
    isDefault: false, createdAt: "2026-04-04T10:00:00Z"
  },
  {
    id: "et5", channel: "EMAIL", templateType: "INTERVIEW_LINK", name: "Rejection Notification",
    subject: "Update on Your Application for {{jobTitle}}",
    body: `<h2>Dear {{candidateName}},</h2>
<p>Thank you for your interest in the <strong>{{jobTitle}}</strong> role at <strong>{{companyName}}</strong> and for taking the time to complete your interview.</p>
<p>After careful consideration, we have decided to move forward with other candidates whose experience more closely aligns with our current needs.</p>
<p>We encourage you to apply for future openings. We wish you the best in your career.</p>
<p>Best regards,<br/>{{companyName}} Hiring Team</p>`,
    isDefault: false, createdAt: "2026-04-05T10:00:00Z"
  },
  {
    id: "et6", channel: "EMAIL", templateType: "DIGEST", name: "Weekly Hiring Digest",
    subject: "Weekly Hiring Report — {{interviewDate}}",
    body: `<h2>Weekly Hiring Summary</h2>
<p>Hi Team,</p>
<p>Here's your weekly hiring summary for <strong>{{companyName}}</strong>:</p>
<ul>
<li><strong>New candidates invited:</strong> 24</li>
<li><strong>Interviews completed:</strong> 18</li>
<li><strong>Candidates shortlisted:</strong> 7</li>
<li><strong>Positions filled:</strong> 2</li>
</ul>
<p>Top performing position: <strong>{{jobTitle}}</strong><br/>Average AI score this week: <strong>72/100</strong></p>
<p>Best,<br/>Ample Hire Team</p>`,
    isDefault: false, createdAt: "2026-04-06T10:00:00Z"
  },

  // ── WHATSAPP TEMPLATES ──
  {
    id: "wt1", channel: "WHATSAPP", templateType: "ACCEPTANCE", name: "Interview Acceptance (WhatsApp)",
    subject: "",
    body: `Hi {{candidateName}} 👋

You've been invited to interview for *{{jobTitle}}* at *{{companyName}}*.

⏰ Opens: {{interviewDate}}
⏳ Expires: {{interviewExpiry}}
📱 Duration: ~20 mins

Please confirm before it expires:
✅ Accept: {{acceptUrl}}
❌ Reject: {{rejectUrl}}

We'll send the interview link once you accept.`,
    isDefault: true, createdAt: "2026-04-01T10:00:00Z"
  },
  {
    id: "wt2", channel: "WHATSAPP", templateType: "REMINDER", name: "Interview Reminder (WhatsApp)",
    subject: "",
    body: `Hi {{candidateName}} 👋

Just a reminder — your invitation for *{{jobTitle}}* at *{{companyName}}* expires on *{{interviewExpiry}}*.

Please confirm: {{acceptUrl}}

— {{companyName}} Team`,
    isDefault: false, createdAt: "2026-04-02T10:00:00Z"
  },
  {
    id: "wt2b", channel: "WHATSAPP", templateType: "INTERVIEW_LINK", name: "Send Interview Link (WhatsApp)",
    subject: "",
    body: `Hi {{candidateName}} ✅

Thanks for accepting! Here's your interview link for *{{jobTitle}}*:

{{interviewUrl}}

📱 Duration: ~20 mins
Make sure you have a camera, mic, and quiet space ready.

Good luck! 🍀`,
    isDefault: true, createdAt: "2026-04-02T11:00:00Z"
  },
  {
    id: "wt3", channel: "WHATSAPP", templateType: "INTERVIEW_LINK", name: "Interview Complete (WhatsApp)",
    subject: "",
    body: `Hi {{candidateName}} ✅

Thanks for completing your interview for *{{jobTitle}}*!

Our team will review your responses and update you within 5 days.

Stay tuned! 🎯`,
    isDefault: false, createdAt: "2026-04-03T10:00:00Z"
  },
  {
    id: "wt4", channel: "WHATSAPP", templateType: "INTERVIEW_LINK", name: "Shortlisted (WhatsApp)",
    subject: "",
    body: `Hi {{candidateName}} 🎉

Great news! You've been *shortlisted* for the next round at *{{companyName}}* for *{{jobTitle}}*.

We'll share next steps shortly. Stay tuned!

— {{companyName}} Team`,
    isDefault: false, createdAt: "2026-04-04T10:00:00Z"
  },
  {
    id: "wt5", channel: "WHATSAPP", templateType: "INVITE", name: "OTP Verification (WhatsApp)",
    subject: "",
    body: `Your Ample Hire verification code is: *{{candidateName}}*

This code expires in 5 minutes. Do not share it with anyone.`,
    isDefault: false, createdAt: "2026-04-05T10:00:00Z"
  },
  {
    id: "wt6", channel: "WHATSAPP", templateType: "INTERVIEW_LINK", name: "Candidate Registration (WhatsApp)",
    subject: "",
    body: `Welcome to *Ample Hire* 🚀

Hi {{candidateName}}, your account has been created successfully.

Email: {{candidateEmail}}

You can now log in and manage your interviews:
{{interviewUrl}}

— Ample Hire Team`,
    isDefault: false, createdAt: "2026-04-06T10:00:00Z"
  },

  // ── SMS TEMPLATES — body must be ≤160 chars (warn at 140) ──
  {
    id: "st1", channel: "SMS", templateType: "ACCEPTANCE", name: "Invite (SMS)",
    subject: "",
    body: `{{companyName}}: Hi {{candidateName}}, you're invited for {{jobTitle}}. Accept: {{acceptUrl}}`,
    isDefault: true, createdAt: "2026-04-07T10:00:00Z"
  },
  {
    id: "st2", channel: "SMS", templateType: "REMINDER", name: "Reminder (SMS)",
    subject: "",
    body: `{{companyName}}: Reminder — your interview invite expires {{interviewExpiry}}. Respond now: {{acceptUrl}}`,
    isDefault: false, createdAt: "2026-04-07T10:00:00Z"
  },
  {
    id: "st3", channel: "SMS", templateType: "INTERVIEW_LINK", name: "Confirm / Send Link (SMS)",
    subject: "",
    body: `{{companyName}}: Your interview link is ready. Start now: {{interviewUrl}} (valid till {{interviewExpiry}})`,
    isDefault: true, createdAt: "2026-04-07T10:00:00Z"
  },
  {
    id: "st4", channel: "SMS", templateType: "REMINDER", name: "Reject (SMS)",
    subject: "",
    body: `{{companyName}}: Thank you for your interest in {{jobTitle}}. We've decided not to move forward. Best of luck.`,
    isDefault: false, createdAt: "2026-04-07T10:00:00Z"
  },
];
